import {gql} from '@apollo/client';

const FRAGMENT_TRANSACTION_ITEM = gql`
  fragment TransactionItem on TransactionType {
    id
    action
    amount
    createdAt
  }
`;

export const QUERY_TRANSACTION_LIST = gql`
  query TransactionList {
    transactionList {
      ...TransactionItem
    }
  }
  ${FRAGMENT_TRANSACTION_ITEM}
`;

export const MUTATION_TRANSACTION_TARIFF = gql`
  mutation TransactionTariff($input: TransactionTariffInput!) {
    transactionTariff(input: $input) {
      obj {
        ...TransactionItem
        client {
          id
          balance
          activeTill
        }
      }
    }
  }
  ${FRAGMENT_TRANSACTION_ITEM}
`;
